module.exports = __webpack_public_path__ + "static/media/am-horizontal-logo.4a4202d3.png";